import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import TotalRewards from '../ReferralPage/TotalRewards';
import PastReferrals from '../ReferralPage/PastReferrals';
import TotalReferral from '../ReferralPage/TotalReferral';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { primary } from 'daisyui/colors/colorNames';
import useBookingSummary from '../../Hooks/use-bookingSummary';
import { isRewardsVisible } from '../../utils/routing';
import useKYC from '../../Hooks/use-KYC';
import KYCModal from '../../Components/Organisms/KYCModal';
import { winnreAuth } from '../../utils/axios';

const Referrals = ({ config }) => {
    const history = useHistory();
    const [allLeads, setAllLeads] = useState([]);
    const { userRole } = useSelector((state) => state.auth);
    const [pastReferralStatus, setPastReferralStatus] = useState('all');
    const { userAccountSummary, getUserAccountSummary } = useBookingSummary();
    const isInternalWebview = useSelector((state) => state.webView.internalWebview);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const dataIssueHandler = () => {
        window?.webengage?.track('ReferralIssue');
        window?.webengage?.track('ContactUsClicked', {
            Section: 'Refer & Earn'
        });
        history.push('/contact-us?referralissue=true');
    };

    const hasReferrals =
        userAccountSummary && userAccountSummary.leadSubmissions > 0;

    const handleReferNowClick = () => {
        window?.webengage?.track('ReferralSection', { From: 'Earn More' });
        if (isInternalWebview && isIOS) {
            var valueToSend = {
                type: 'OPEN_REFERRAL_IN_BROWSER',                                  
            };
            window?.webkit?.messageHandlers?.jsMessageHandler.postMessage(
                valueToSend
            );
        } else {
            history.push('/gift-and-earn');
        }
    };

    const fetchUsersLeads = () => {
        winnreAuth({
            method: 'get',
            url: `/winnre/user/enquiry?pageSize=50`
        })
            .then((res) => {
                console.log('past referral', res?.content);
                setAllLeads(res.content);
            })
            .catch(() => {
                setAllLeads([]);
            });
    };
    useEffect(() => {
        fetchUsersLeads();
    }, []);

    // const claimHandler = (forceInitate, silentCheck, cashoutProcess) => {
    //     if (isRewardsVisible) {
    //         history.push('/rewardStore');
    //     }
    //     checkKycVerificationStatus(forceInitate, silentCheck, cashoutProcess);
    //     setOpenKYCModal(true);
    //     setError(null);
    // };
    const claimHandler = () => {
        history.push('/rewardStore');
    };

    const {
        step,
        setStep,
        error,
        setError,
        showError,
        checkKycVerificationStatus,
        closeKYCModal,
        setOpenKYCModal,
        openKYCModal,
        loading,
        checkBankVerificationStatus,
        isUpdateWorkflow,
        isKycCompleted,
        initiateWorkflow,
        claimInProgress,
        rewardTypeSelected,
        cashOutFlow
    } = useKYC();

    const closeModal = () => {
        closeKYCModal();
        getUserAccountSummary();
    };

    return (
        <>
            <div className=" w-full lg:pl-5 2xl:pl-7">
                <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-4 w-full">
                    <div>
                        <h1 className="text-black text-lg md:text-xl font-bold">
                            {/* Refer & Earn */}
                            Referral Summary
                        </h1>
                        <h3 className=" font-Poppins pt-1 text-sm">
                            Track your ongoing enquires and claim your rewards
                        </h3>
                    </div>
                    {isRewardsVisible && (
                        <div className="flex justify-between gap-x-2">
                            <button
                                // onClick={() => claimHandler(false, true, true)}
                                onClick={claimHandler}
                                className="text-primary border-primary border-2 px-5 py-[6px] md:px-7 md:py-2 rounded-md "
                            >
                                Claim
                            </button>
                            {/* {hasReferrals && ( */}
                            <button
                                className="bg-primary text-white px-3 py-[6px] md:px-4 md:py-2 rounded-md"
                                onClick={handleReferNowClick}
                            >
                                Earn More
                            </button>
                            {/* )} */}
                        </div>
                    )}

                    {/* <div>
                            {(userRole == 'CUSTOMER' ||
                                (userRole == 'EMPLOYEE' &&
                                    config?.referralForm?.userTypes?.employee &&
                                    userAccountSummary?.commissionEarned)) && (
                                <div className="rounded-xl ">
                                    <TotalRewards
                                        userAccountSummary={userAccountSummary}
                                        config={config}
                                        getUserAccountSummary={
                                            getUserAccountSummary
                                        }
                                    />
                                </div>
                            )}
                        </div> */}
                </div>

                {(userRole == 'CUSTOMER' ||
                    (userRole == 'EMPLOYEE' &&
                        config?.referralForm?.userTypes?.employee &&
                        userAccountSummary?.commissionEarned)) && (
                    <div className="rounded-xl ">
                        <TotalRewards
                            userAccountSummary={userAccountSummary}
                            config={config}
                            getUserAccountSummary={getUserAccountSummary}
                        />
                    </div>
                )}

                <button
                    className=" flex items-center  gap-1 text-primary cursor-pointer mt-10 "
                    onClick={dataIssueHandler}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                    >
                        <g
                            id="_4213468_help_lifesaver_support_icon"
                            data-name="4213468_help_lifesaver_support_icon"
                            transform="translate(-1.2 -1.2)"
                        >
                            <path
                                id="Path_7102"
                                data-name="Path 7102"
                                d="M11.2,1.2a10,10,0,1,0,10,10A10,10,0,0,0,11.2,1.2Zm0,1.21A8.683,8.683,0,0,1,16.869,4.5l-2.42,2.4a5.351,5.351,0,0,0-6.5,0L5.531,4.5A8.768,8.768,0,0,1,11.2,2.41Zm4.172,8.79A4.172,4.172,0,1,1,11.2,7.028,4.176,4.176,0,0,1,15.372,11.2ZM2.41,11.2A8.668,8.668,0,0,1,4.655,5.356l2.4,2.4a5.368,5.368,0,0,0-.143,6.688L4.5,16.869A8.768,8.768,0,0,1,2.41,11.2Zm8.79,8.79a8.668,8.668,0,0,1-5.844-2.245l2.4-2.4a5.383,5.383,0,0,0,6.879,0l2.4,2.4A8.746,8.746,0,0,1,11.2,19.99Zm6.7-3.121-2.4-2.42A5.4,5.4,0,0,0,16.6,11.2a5.321,5.321,0,0,0-1.242-3.439l2.4-2.4A8.776,8.776,0,0,1,20.006,11.2,8.868,8.868,0,0,1,17.9,16.869Z"
                                transform="translate(0 0)"
                                fill={config?.primaryColor}
                            />
                        </g>
                    </svg>
                    <p className="underline text-sm font-semibold">
                        Data not reflecting correctly?
                    </p>
                </button>

                <div className="w-full">
                    {(userRole == 'CUSTOMER' ||
                        (userRole == 'EMPLOYEE' &&
                            config?.referralForm?.userTypes?.employee) ||
                        (userRole == 'SITE_VISITOR' &&
                            config?.referralForm?.userTypes?.siteVisitor)) && (
                        <div
                            className={`${
                                config?.darkMode ? 'bg-black' : 'bg-transparent'
                            } py-0 rounded-xl`}
                        >
                            <TotalReferral
                                allLeads={allLeads}
                                userAccountSummary={userAccountSummary}
                                active={pastReferralStatus}
                                setActive={setPastReferralStatus}
                            />
                            <PastReferrals active={pastReferralStatus} />
                        </div>
                    )}
                </div>
            </div>

            <KYCModal
                visible={openKYCModal}
                onClick={closeModal}
                userAccountSummary={userAccountSummary}
                getUserAccountSummary={getUserAccountSummary}
                setOpenKYCModal={setOpenKYCModal}
                closeKYCModal={closeModal}
                step={step}
                setStep={setStep}
                checkKycVerificationStatus={checkKycVerificationStatus}
                loading={loading}
                checkBankVerificationStatus={checkBankVerificationStatus}
                isUpdateWorkflow={isUpdateWorkflow}
                isKycCompleted={isKycCompleted}
                initiateWorkflow={initiateWorkflow}
                claimInProgress={claimInProgress}
                rewardTypeSelected={rewardTypeSelected}
                cashOutFlow={cashOutFlow}
            />
        </>
    );
};

export default Referrals;
